<div class="page gray-font-color font-family employment-history">
  <div class="header-navigation-back">
    <mat-icon (click)="goBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">Unemployment Form</span>
  </div>
  <div>
    @if (errorMessage) {
      <mat-error class="error padding-left-md">
        {{ errorMessage }}
      </mat-error>
    }
  </div>
  @if (!isContentReady) {
    <app-skeleton-emp-residence-history
      isResidenceHistory="false"
    ></app-skeleton-emp-residence-history>
  }
  <div [hidden]="!isContentReady">
    <div class="content" >
      <div class="component-container">
        <div [formGroup]="unEmpForm" class="addUnemployment">
          <div class="form-title">{{ editFormTitle }}</div>

          <div class="address-fields" >
            <!-- FROM Date: Month and Year Dropdowns -->
            <div class="date-selector-row" #datePickerSection>
              <mat-form-field class="half-width">
                <mat-label>FROM MONTH</mat-label>
                <mat-select formControlName="fromMonth" data-testid="from-month" required>
                  @for (month of getAvailableFromMonths(); track month) {
                  <mat-option [value]="month.value">
                    {{ month.name }}
                  </mat-option>
                  }
                </mat-select>
                @if (unEmpForm.get('fromMonth')?.touched && unEmpForm.get('fromMonth')?.invalid) {
                <mat-error>
                  Month is required
                </mat-error>
                }
              </mat-form-field>
              
              <mat-form-field class="half-width">
                <mat-label>FROM YEAR</mat-label>
                <mat-select formControlName="fromYear" data-testid="from-year" required>
                  @for (year of getAvailableFromYears(); track year) {
                  <mat-option [value]="year">
                    {{ year }}
                  </mat-option>
                  }
                </mat-select>
                @if (unEmpForm.get('fromYear')?.touched && unEmpForm.get('fromYear')?.invalid) {
                <mat-error>
                  Year is required
                </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- TO Date: Display text for current unemployment, dropdowns for previous unemployment -->
            <div class="date-selector-row">
              @if (isFirstRecord || isCurrentUnemployment?.value) {
              <!-- Show text for current unemployment -->
              <div class="half-width current-address-date-display">
                <label class="date-label">TO MONTH</label>
                <div class="date-value">{{ getCurrentMonthName() }}</div>
              </div>
              
              <div class="half-width current-address-date-display">
                <label class="date-label">TO YEAR</label>
                <div class="date-value">{{ getCurrentYear() }}</div>
              </div>
              } @else {
              <!-- Show dropdowns for previous unemployment -->
              <mat-form-field class="half-width">
                <mat-label>TO MONTH</mat-label>
                <mat-select formControlName="toMonth" data-testid="to-month" required>
                  @for (month of getAvailableToMonths(); track month) {
                  <mat-option [value]="month.value">
                    {{ month.name }}
                  </mat-option>
                  }
                </mat-select>
                @if (unEmpForm.get('toMonth')?.touched && unEmpForm.get('toMonth')?.invalid) {
                <mat-error>
                  Month is required
                </mat-error>
                }
              </mat-form-field>
              
              <mat-form-field class="half-width">
                <mat-label>TO YEAR</mat-label>
                <mat-select formControlName="toYear" data-testid="to-year" required>
                  @for (year of getAvailableToYears(); track year) {
                  <mat-option [value]="year">
                    {{ year }}
                  </mat-option>
                  }
                </mat-select>
                @if (unEmpForm.get('toYear')?.touched && unEmpForm.get('toYear')?.invalid) {
                <mat-error>
                  Year is required
                </mat-error>
                }
              </mat-form-field>
              }
            </div>

            @if (!isCurrentUnemployment?.value && (unEmpForm.get('toMonth')?.touched || unEmpForm.get('toYear')?.touched) && unEmpForm.get('toDate')?.errors?.minDateError) {
            <mat-error class="padding-left-md">
              End date must be after start date.
            </mat-error>
            }
            @if (!isCurrentUnemployment?.value && (unEmpForm.get('toMonth')?.touched || unEmpForm.get('toYear')?.touched) && unEmpForm.get('toDate')?.errors?.futureToDateError) {
            <mat-error class="padding-left-md">
              End date cannot be in the future.
            </mat-error>
            }

            <!-- Overlap Error Message -->
            @if (errorMessage) {
            <div class="date-overlap-error">
              <mat-icon class="error-icon">error</mat-icon>
              <div class="error-message">{{ errorMessage }}</div>
            </div>
            }

            <!-- Overlap Warning Message -->
            @if (overlapWarningMessage) {
            <div class="date-overlap-warning">
              <mat-icon class="warning-icon">warning</mat-icon>
              <div class="warning-message">{{ overlapWarningMessage }}</div>
            </div>
            }

            <mat-form-field class="full-width">
              <input matInput placeholder="Reason" formControlName="reason" data-test="reason-form-field" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    
    <div class="fixed-footer">
      <button mat-button class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button
        mat-button
        class="btn-save"
        (click)="onSubmit(unEmpForm)"
        [disabled]="!unEmpForm.valid || errorMessage"
        data-test="save-button-form-field"
        >
        Save
      </button>
    </div>
  </div>
</div>
